import { observer } from 'mobx-react-lite'
import { Tooltip } from 'shared/ui'
import { type ISwitchActionProps, SwitchAction } from 'shared/ui/SwitchAction'
import { SurveysStatus } from 'entities/Surveys/api/types'

type Props = {
  item: { id: number; status: SurveysStatus }
  onToggle: () => Promise<void>
  size?: ISwitchActionProps['size']
  className?: string
}

export const SurveyActiveToggle = observer(
  ({ item, onToggle, size = 'small', className }: Props) => {
    const isDraft = item.status === SurveysStatus.Draft
    const tooltipLabel = isDraft ? 'Complete required info to enable' : ''

    return (
      <div className={className}>
        <Tooltip label={tooltipLabel} placement={'top'}>
          <SwitchAction
            size={size}
            active={item.status === SurveysStatus.Active}
            disabled={isDraft}
            onTrigger={onToggle}
            ariaLabel={`SurveyActiveToggle-${item.id}`}
          />
        </Tooltip>
      </div>
    )
  }
)
